import { Select } from 'antd';
import moment from 'moment';
import React from 'react';
import styled, { useTheme } from 'styled-components';
import { Button } from '../../components/Button/Button';
import { useAppSelector } from '../../logic/store/Store';
import { ReportView } from './Report';
import { FeedbackThumbs } from './Feedback';
import { ArrowBackIcon } from './Icons/ArrowBackIcon';
import { SectionHeader } from './Components/SectionHeader';

const StyledDateRowContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 12px;

	// mobile
	@media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
		.ant-select {
			width: 100% !important;
		}
	}
`;


interface IGrowerViewProps
{
	backToLastView: () => void;
	changeSnapshotDate: (Id: string, snapshotDate: string) => void;
}

export const GrowerView = (props: IGrowerViewProps) =>
{
	const theme = useTheme();

	const { backToLastView, changeSnapshotDate } = props;

	const aiexperience = useAppSelector(s => s.insights.aiExperience);
	const selectedGrowerId = useAppSelector(s => s.insights.currentGrowerId);
	const selectedGrowerAnalysis = useAppSelector(s => s.insights.singleGrowerAnalysis);

	// Change the troubleshooting tool's snapshot date
	const onChangeSnapshotDate = (date: string) =>
	{
		if (!date)
		{
			return;
		}
		
		changeSnapshotDate(selectedGrowerId, date);
	};

	const startYear = (new Date().getFullYear()-1).toString();

	return (
		<div 
			style={{ 
				display: 'flex', 
				flexDirection: 'column',
				width: '100%', 
				height: '98%', 
				overflow: 'hidden',
			}}>
			<SectionHeader>
				{
					(aiexperience === 'MultiSalesRep' || aiexperience === 'SalesRep' || aiexperience === 'Seller')  && (
						<Button 
							variant='light' 
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								height: 32,
								width: 32,
							}}
							title='Back to Grower List'
							onClick={backToLastView}
						>
							<ArrowBackIcon style={{transform: 'translateY(-1px)'}} />
						</Button>
					)}
					Grower - {selectedGrowerAnalysis?.GrowerName}
			</SectionHeader>
			<div style={{ 
				display: 'flex', 
				overflowY: 'auto', 
				flexDirection: 'column', 
				padding: '20px 0px',
			}}>
				<StyledDateRowContainer>
					<span style={{ fontWeight: theme.fontWeights.bold, minWidth: 90 }}>Report Date:</span>
					<Select value={selectedGrowerAnalysis?.SnapshotDate} style={{ width: 150 }} onChange={onChangeSnapshotDate}>
						{
							selectedGrowerAnalysis?.AvailableDates?.filter(ad => ad > startYear).sort().reverse().map(date => (
								<Select.Option key={date} value={date}>
									{moment(date, 'YYYY-MM-DD').format('L')}
								</Select.Option>
							))
						}
					</Select>
				</StyledDateRowContainer>
				<div style={{ width: '95%', display: 'flex', flexDirection: 'row', marginTop: 10, marginBottom: 20, gap: 6 }}>
					<div style={{ display: 'flex', flexDirection: 'column', minWidth: 90 }}>
						<div style={{ fontWeight: theme.fontWeights.bold, marginBottom: 5 }}>
							Overview:
						</div>
						<FeedbackThumbs report={selectedGrowerAnalysis?.Report} />
					</div>
					<div style={{ marginLeft: 10 }}>{selectedGrowerAnalysis?.Report?.Overview}</div>
				</div>
				<ReportView report={selectedGrowerAnalysis?.Report} />
			</div>
		</div>
	);
};
